var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.tooltipContent,"placement":"bottom","disabled":!_vm.isEllipsis}},[_c('div',{ref:"textRef",staticClass:"ellipsis-tooltip",on:{"mouseenter":_vm.handleMouseEnter}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }